export const DEFAULT_PAGE_SIZE = 30;

/**
 * Page size used by the patient list. Intentionally large so the list shows
 * essentially everything in one fetch — the table is sortable client-side,
 * so a small page would only sort the first N rows. Other infinite tables
 * on the patient page should keep the smaller `DEFAULT_PAGE_SIZE`.
 */
export const PATIENT_LIST_PAGE_SIZE = 100000;
